export default __webpack_public_path__ + "static/media/regulatory--speeding-fines-increased--g1.31b9fc1b.png";